"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";

const DARK_PAGES = ["/about", "/blog", "/contact", "/portfolio"];

/**
 * Client component that sets body background color based on current route.
 * Dark pages (about, blog, contact, portfolio) get a dark background.
 * Re-runs on every client-side navigation via usePathname().
 */
export function DarkPageBackground() {
	const pathname = usePathname();

	useEffect(() => {
		const isDarkPage = DARK_PAGES.some(
			(p) => pathname === p || pathname.startsWith(`${p}/`),
		);

		document.body.style.backgroundColor = isDarkPage ? "#09090b" : "";
	}, [pathname]);

	return null;
}
